import { motion } from "framer-motion";
import { Boxes, ShieldCheck, ScrollText, Smartphone, Plug, TestTube2, DatabaseBackup, GitBranch } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { HOME_I18N } from "../i18n/home";

const ICONS = [Boxes, ShieldCheck, ScrollText, Smartphone, Plug, TestTube2, DatabaseBackup, GitBranch];

export default function TrustSection() {
  const { lang } = useLang();
  const t = HOME_I18N[lang].trust;

  return (
    <section className="section bg-[#F8FAFC]" data-testid="trust-section">
      <div className="container-x grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="eyebrow">{t.eyebrow}</span>
          <h2 className="mt-3 h2-section">
            {t.title1}<br />
            <span className="text-[#2563EB]">{t.titleAccent}</span>
          </h2>
          <p className="mt-5 body-lg max-w-md">{t.desc}</p>
        </div>

        <div className="lg:col-span-7">
          <ul className="grid gap-3 sm:grid-cols-2" data-testid="trust-list">
            {t.items.map((label, i) => {
              const Icon = ICONS[i];
              return (
                <motion.li
                  key={label}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.04 }}
                  className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:shadow-md hover:-translate-y-0.5"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#07111F] text-[#22D3EE]">
                    <Icon className="h-4 w-4" strokeWidth={1.8} />
                  </span>
                  <span className="text-sm sm:text-base font-medium text-[#07111F] leading-snug">{label}</span>
                </motion.li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
